import { type QueryFunctionContext, useQuery } from '@tanstack/react-query';
import { keys } from '@/api/queryKeys';
import { calendarApi } from '../api/calendarApi';
import { filterParamsKey, type CalendarQueryParams } from '../api/calendarFilterParams';
import { keepWhenOnlyFiltersChange } from './keepWhenOnlyFiltersChange';

export function useCalendarNext7(
  locationId: number | null | undefined,
  start: string,
  options?: { enabled?: boolean; filters?: CalendarQueryParams },
) {
  const filters = options?.filters ?? {};
  const queryKey = keys.calendar.next7(locationId ?? 0, start, filterParamsKey(filters));
  return useQuery({
    queryKey,
    queryFn: ({ signal }: QueryFunctionContext) => calendarApi.getNext7(locationId!, start, filters, { signal }),
    enabled: (options?.enabled ?? true) && locationId != null && !!start,
    staleTime: 90_000,
    refetchOnMount: 'always',
    placeholderData: keepWhenOnlyFiltersChange<Awaited<ReturnType<typeof calendarApi.getNext7>>>(queryKey),
  });
}
